import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5fe2d53e")

_pushScopeId("data-v-5fe2d53e")
const _hoisted_1 = {
  class: "container regular-container",
  id: "product-page"
}
const _hoisted_2 = { class: "page-header-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_6 = { class: "card" }
const _hoisted_7 = {
  class: "card-header collapsed",
  id: "headingProductDetails",
  "data-toggle": "collapse",
  "data-target": "#productDetails"
}
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productDetails"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_11 = {
  id: "productDetails",
  class: "collapse",
  "aria-labelledby": "headingProductDetails",
  "data-parent": "#accordionExample"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  class: "several-section row mx-auto",
  style: {"position":"relative"}
}
const _hoisted_14 = { class: "col-12 col-lg-6" }
const _hoisted_15 = { class: "product-title" }
const _hoisted_16 = { class: "product-text" }
const _hoisted_17 = { class: "col-12 col-lg-6" }
const _hoisted_18 = { class: "product-title" }
const _hoisted_19 = { class: "product-text" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "product-title" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "product-title" }
const _hoisted_24 = { class: "several-section row mx-auto" }
const _hoisted_25 = { class: "col-12 col-lg-6" }
const _hoisted_26 = { class: "product-title" }
const _hoisted_27 = { class: "product-text" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "several-section" }
const _hoisted_30 = { class: "tag-wrapper row mx-auto" }
const _hoisted_31 = { class: "col-12 col-lg-6" }
const _hoisted_32 = { class: "title-wrapper" }
const _hoisted_33 = { class: "product-title" }
const _hoisted_34 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "col-12 col-lg-6" }
const _hoisted_37 = { class: "title-wrapper" }
const _hoisted_38 = { class: "product-title" }
const _hoisted_39 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "col-12 col-lg-6" }
const _hoisted_42 = { class: "title-wrapper" }
const _hoisted_43 = { class: "product-title" }
const _hoisted_44 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "col-12 col-lg-6" }
const _hoisted_47 = { class: "title-wrapper" }
const _hoisted_48 = { class: "product-title" }
const _hoisted_49 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "col-12 col-lg-6" }
const _hoisted_52 = { class: "title-wrapper" }
const _hoisted_53 = { class: "product-title" }
const _hoisted_54 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "col-12 col-lg-6" }
const _hoisted_57 = { class: "title-wrapper" }
const _hoisted_58 = { class: "product-title" }
const _hoisted_59 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "col-12 col-lg-6" }
const _hoisted_62 = { class: "title-wrapper" }
const _hoisted_63 = { class: "product-title" }
const _hoisted_64 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { class: "col-12 col-lg-6" }
const _hoisted_67 = { class: "title-wrapper" }
const _hoisted_68 = { class: "product-title" }
const _hoisted_69 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "col-12 col-lg-6" }
const _hoisted_72 = { class: "title-wrapper" }
const _hoisted_73 = { class: "product-title" }
const _hoisted_74 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "several-section row mx-auto" }
const _hoisted_77 = { class: "col-12 col-lg-6" }
const _hoisted_78 = { class: "product-title" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { class: "col-12 col-lg-6" }
const _hoisted_81 = { class: "product-title" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { class: "several-section row mx-auto" }
const _hoisted_84 = { class: "col-12" }
const _hoisted_85 = { class: "product-title" }
const _hoisted_86 = { class: "product-text" }
const _hoisted_87 = { class: "several-section row mx-auto" }
const _hoisted_88 = { class: "col-12" }
const _hoisted_89 = { class: "product-title" }
const _hoisted_90 = {
  key: 0,
  class: "product-text"
}
const _hoisted_91 = { class: "several-section row mx-auto" }
const _hoisted_92 = { class: "col-12" }
const _hoisted_93 = { class: "product-title" }
const _hoisted_94 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_95 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_96 = { class: "card collapsed" }
const _hoisted_97 = {
  class: "card-header collapsed",
  id: "headingproductAddress",
  "data-toggle": "collapse",
  "data-target": "#productAddress"
}
const _hoisted_98 = { class: "mb-0" }
const _hoisted_99 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productAddress"
}
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_101 = {
  id: "productAddress",
  class: "collapse",
  "aria-labelledby": "headingproductAddress",
  "data-parent": "#accordionExample"
}
const _hoisted_102 = { class: "card-body" }
const _hoisted_103 = {
  class: "several-section",
  style: {"z-index":"1"}
}
const _hoisted_104 = {
  class: "col-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_105 = { class: "product-title" }
const _hoisted_106 = { class: "product-text mb-0" }
const _hoisted_107 = {
  key: 0,
  class: "col-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_108 = { class: "product-title" }
const _hoisted_109 = {
  ref: "map",
  id: "map"
}
const _hoisted_110 = {
  class: "col-12 col-lg-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_111 = { class: "product-title" }
const _hoisted_112 = {
  key: 0,
  class: "product-text mb-0"
}
const _hoisted_113 = {
  class: "col-12 col-lg-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_114 = { class: "product-title" }
const _hoisted_115 = {
  key: 0,
  class: "product-text mb-0"
}
const _hoisted_116 = {
  class: "col-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_117 = { class: "product-title" }
const _hoisted_118 = {
  class: "col-12",
  style: {"margin-bottom":"20px"}
}
const _hoisted_119 = { class: "product-title" }
const _hoisted_120 = { class: "card" }
const _hoisted_121 = {
  class: "card-header collapsed",
  id: "headingProductMoreInfo",
  "data-toggle": "collapse",
  "data-target": "#productMoreInfo"
}
const _hoisted_122 = { class: "mb-0" }
const _hoisted_123 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productMoreInfo"
}
const _hoisted_124 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_125 = {
  id: "productMoreInfo",
  class: "collapse",
  "aria-labelledby": "headingProductMoreInfo",
  "data-parent": "#accordionExample"
}
const _hoisted_126 = { class: "card-body" }
const _hoisted_127 = { class: "several-section row mx-auto col-12" }
const _hoisted_128 = { class: "card" }
const _hoisted_129 = {
  class: "card-header collapsed",
  id: "headingProductActivityTimeDuration",
  "data-toggle": "collapse",
  "data-target": "#productActivityTimeDuration"
}
const _hoisted_130 = { class: "mb-0" }
const _hoisted_131 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productActivityTimeDuration"
}
const _hoisted_132 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_133 = {
  id: "productActivityTimeDuration",
  class: "collapse",
  "aria-labelledby": "headingProductActivityTimeDuration",
  "data-parent": "#accordionExample"
}
const _hoisted_134 = { class: "card-body" }
const _hoisted_135 = {
  class: "several-section p-relative mb-0",
  style: {"text-align":"center"}
}
const _hoisted_136 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_138 = { class: "several-section" }
const _hoisted_139 = { class: "card" }
const _hoisted_140 = {
  class: "card-header collapsed",
  id: "headingProductPhotosVideo",
  "data-toggle": "collapse",
  "data-target": "#productPhotosVideo"
}
const _hoisted_141 = { class: "mb-0" }
const _hoisted_142 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productPhotosVideo"
}
const _hoisted_143 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_144 = {
  id: "productPhotosVideo",
  class: "collapse",
  "aria-labelledby": "headingProductPhotosVideo",
  "data-parent": "#accordionExample"
}
const _hoisted_145 = { class: "card-body" }
const _hoisted_146 = { class: "several-section" }
const _hoisted_147 = {
  key: 0,
  class: "row mx-auto col-12 images-order",
  style: {"margin":"0"}
}
const _hoisted_148 = { class: "photo-wrapper" }
const _hoisted_149 = {
  key: 0,
  class: "not-confirmed-label-wrapper"
}
const _hoisted_150 = { class: "warning-info-text" }
const _hoisted_151 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_152 = {
  key: 1,
  class: "span covered"
}
const _hoisted_153 = {
  key: 1,
  class: "row mx-auto col-12"
}
const _hoisted_154 = {
  class: "product-title",
  style: {"text-align":"center","width":"100%"}
}
const _hoisted_155 = { class: "several-section" }
const _hoisted_156 = { class: "col-12" }
const _hoisted_157 = { class: "row" }
const _hoisted_158 = { class: "col-10" }
const _hoisted_159 = {
  key: 0,
  class: "tickets-title"
}
const _hoisted_160 = {
  key: 0,
  class: "row mx-auto col-12 images-order",
  style: {"margin":"0"}
}
const _hoisted_161 = { class: "col-4 col-md-3 photo-container pointer" }
const _hoisted_162 = { class: "photo-wrapper ticket-wrapper" }
const _hoisted_163 = { class: "col-4 col-md-3 photo-container pointer" }
const _hoisted_164 = { class: "photo-wrapper ticket-wrapper" }
const _hoisted_165 = { class: "several-section" }
const _hoisted_166 = { class: "product-title row mx-auto col-12" }
const _hoisted_167 = { class: "url-link-wrapper" }
const _hoisted_168 = {
  key: 1,
  class: "product-title",
  style: {"text-align":"center","width":"100%"}
}
const _hoisted_169 = { class: "card" }
const _hoisted_170 = {
  class: "card-header collapsed",
  id: "headingProductDocuments",
  "data-toggle": "collapse",
  "data-target": "#productDocuments"
}
const _hoisted_171 = { class: "mb-0" }
const _hoisted_172 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productDocuments"
}
const _hoisted_173 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_174 = {
  id: "productDocuments",
  class: "collapse",
  "aria-labelledby": "headingProductDocuments",
  "data-parent": "#accordionExample"
}
const _hoisted_175 = { class: "card-body" }
const _hoisted_176 = { class: "several-section" }
const _hoisted_177 = {
  key: 0,
  class: "row mx-auto col-12",
  style: {"margin":"0"}
}
const _hoisted_178 = { class: "document-wrapper" }
const _hoisted_179 = {
  class: "file-link",
  style: {"margin-bottom":"15px !important"}
}
const _hoisted_180 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-lens fs-24" }, null, -1)
const _hoisted_181 = {
  key: 1,
  class: "row mx-auto col-12"
}
const _hoisted_182 = {
  class: "product-title",
  style: {"text-align":"center","width":"100%"}
}
const _hoisted_183 = { class: "card" }
const _hoisted_184 = {
  class: "card-header collapsed",
  id: "headingProductPricing",
  "data-toggle": "collapse",
  "data-target": "#productPricing"
}
const _hoisted_185 = { class: "mb-0" }
const _hoisted_186 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productPricing"
}
const _hoisted_187 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_188 = {
  id: "productPricing",
  class: "collapse",
  "aria-labelledby": "headingProductPricing",
  "data-parent": "#accordionExample"
}
const _hoisted_189 = { class: "card-body" }
const _hoisted_190 = { class: "row" }
const _hoisted_191 = { class: "col-11" }
const _hoisted_192 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_193 = { class: "pricing-row row mx-auto" }
const _hoisted_194 = { class: "col-6 col-lg-3 pricing-name" }
const _hoisted_195 = { class: "product-title" }
const _hoisted_196 = { class: "product-text" }
const _hoisted_197 = { class: "col-6 col-lg-3" }
const _hoisted_198 = /*#__PURE__*/_createVNode("p", { class: "product-title" }, "Date", -1)
const _hoisted_199 = { class: "product-text" }
const _hoisted_200 = { class: "product-text" }
const _hoisted_201 = { class: "col-6 col-lg-3 p-end-0 p-start-45" }
const _hoisted_202 = { class: "product-title" }
const _hoisted_203 = { class: "product-text" }
const _hoisted_204 = { class: "col-6 col-lg-3 p-start-45" }
const _hoisted_205 = { class: "product-title" }
const _hoisted_206 = { class: "product-text" }
const _hoisted_207 = { class: "card" }
const _hoisted_208 = {
  class: "card-header collapsed",
  id: "headingProductFAQ",
  "data-toggle": "collapse",
  "data-target": "#productFAQ"
}
const _hoisted_209 = { class: "mb-0" }
const _hoisted_210 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productFAQ"
}
const _hoisted_211 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_212 = {
  id: "productFAQ",
  class: "collapse",
  "aria-labelledby": "headingProductFAQ",
  "data-parent": "#accordionExample"
}
const _hoisted_213 = { class: "card-body" }
const _hoisted_214 = { class: "several-section row mx-auto col-12" }
const _hoisted_215 = {
  class: "product-title",
  style: {"text-align":"center","width":"100%"}
}
const _hoisted_216 = {
  key: 0,
  class: "card"
}
const _hoisted_217 = {
  class: "card-header collapsed",
  id: "headingProfiles",
  "data-toggle": "collapse",
  "data-target": "#notoficationsRestrictions"
}
const _hoisted_218 = { class: "mb-0" }
const _hoisted_219 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "notoficationsRestrictions"
}
const _hoisted_220 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_221 = {
  id: "notoficationsRestrictions",
  class: "collapse",
  "aria-labelledby": "notoficationsRestrictions",
  "data-parent": "#accordionExample"
}
const _hoisted_222 = { class: "card-body default-card-body" }
const _hoisted_223 = { class: "several-section" }
const _hoisted_224 = { class: "card" }
const _hoisted_225 = {
  class: "card-header collapsed",
  id: "headingProductGeneral",
  "data-toggle": "collapse",
  "data-target": "#productGeneral"
}
const _hoisted_226 = { class: "mb-0" }
const _hoisted_227 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productGeneral"
}
const _hoisted_228 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_229 = {
  id: "productGeneral",
  class: "collapse",
  "aria-labelledby": "headingProductGeneral",
  "data-parent": "#accordionExample"
}
const _hoisted_230 = { class: "card-body" }
const _hoisted_231 = { class: "several-section row mx-auto col-12" }
const _hoisted_232 = { class: "col-12 col-lg-4" }
const _hoisted_233 = { class: "product-title" }
const _hoisted_234 = { class: "product-text" }
const _hoisted_235 = { class: "col-12 col-lg-4" }
const _hoisted_236 = { class: "product-title" }
const _hoisted_237 = { class: "product-text" }
const _hoisted_238 = { class: "col-12 col-lg-4" }
const _hoisted_239 = { class: "product-title" }
const _hoisted_240 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_241 = { class: "product-title" }
const _hoisted_242 = { class: "product-text text-link" }
const _hoisted_243 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_244 = { class: "product-title" }
const _hoisted_245 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_246 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_247 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_248 = { class: "product-title" }
const _hoisted_249 = { class: "product-text" }
const _hoisted_250 = { class: "col-lg-4 col-12 mt-12" }
const _hoisted_251 = { class: "product-title" }
const _hoisted_252 = { class: "product-text" }
const _hoisted_253 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_254 = { class: "product-title" }
const _hoisted_255 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_256 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_257 = { class: "col-12 col-lg-4 mt-12" }
const _hoisted_258 = { class: "product-title" }
const _hoisted_259 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_260 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_261 = { class: "col-12 mt-2" }
const _hoisted_262 = { class: "product-title" }
const _hoisted_263 = {
  key: 0,
  class: "product-text"
}
const _hoisted_264 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_265 = {
  key: 2,
  class: "product-text not-active text-uppercase"
}
const _hoisted_266 = { class: "col-12 col-lg-6 mt-12" }
const _hoisted_267 = { class: "product-title" }
const _hoisted_268 = { class: "product-text" }
const _hoisted_269 = {
  key: 0,
  class: "col-12 col-lg-6 mt-12"
}
const _hoisted_270 = { class: "product-title" }
const _hoisted_271 = { class: "product-text" }
const _hoisted_272 = { class: "col-12 mt-12" }
const _hoisted_273 = { class: "product-title" }
const _hoisted_274 = { class: "col-12" }
const _hoisted_275 = { class: "product-text" }
const _hoisted_276 = { class: "product-title" }
const _hoisted_277 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_278 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_279 = { class: "col-12 mt-12" }
const _hoisted_280 = { class: "product-title" }
const _hoisted_281 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_282 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_283 = /*#__PURE__*/_createVNode("div", { class: "col-11 row-border" }, null, -1)
const _hoisted_284 = {
  key: 1,
  class: "col-12 pt-3"
}
const _hoisted_285 = { class: "checkboxtext price-per-person-text" }
const _hoisted_286 = { class: "form-text price-per-person-example" }
const _hoisted_287 = {
  key: 2,
  class: "col-12 pt-3"
}
const _hoisted_288 = { class: "checkboxtext price-per-person-text" }
const _hoisted_289 = { class: "form-text price-per-person-example" }
const _hoisted_290 = { class: "card" }
const _hoisted_291 = {
  class: "card-header collapsed",
  id: "headingProductAboutMe",
  "data-toggle": "collapse",
  "data-target": "#productAboutMe"
}
const _hoisted_292 = { class: "mb-0" }
const _hoisted_293 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productAboutMe"
}
const _hoisted_294 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_295 = {
  id: "productAboutMe",
  class: "collapse",
  "aria-labelledby": "headingProductAboutMe",
  "data-parent": "#accordionExample"
}
const _hoisted_296 = { class: "card-body" }
const _hoisted_297 = { class: "several-section about-me-section" }
const _hoisted_298 = {
  key: 0,
  class: "respons-person-image-block"
}
const _hoisted_299 = { class: "product-title" }
const _hoisted_300 = { class: "product-text" }
const _hoisted_301 = { class: "respons-person-description-block" }
const _hoisted_302 = { class: "product-title" }
const _hoisted_303 = { class: "product-text" }
const _hoisted_304 = { class: "card" }
const _hoisted_305 = {
  class: "card-header collapsed",
  id: "headingSellingSettings",
  "data-toggle": "collapse",
  "data-target": "#productSellingSettings"
}
const _hoisted_306 = { class: "mb-0" }
const _hoisted_307 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "productSellingSettings"
}
const _hoisted_308 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_309 = {
  id: "productSellingSettings",
  class: "collapse",
  "aria-labelledby": "headingSellingSettings",
  "data-parent": "#accordionExample"
}
const _hoisted_310 = { class: "card-body" }
const _hoisted_311 = { class: "several-section row mx-auto col-12" }
const _hoisted_312 = { class: "product-edit-container" }
const _hoisted_313 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
const _hoisted_314 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_315 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_316 = {
  type: "button",
  class: "order-modify-button-wrapper dark-circle-button"
}
const _hoisted_317 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_318 = {
  class: "order-modify-button-wrapper edit-order",
  type: "button"
}
const _hoisted_319 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-20 text-white" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProductMoreInfo = _resolveComponent("ProductMoreInfo")
  const _component_ProductSlotsTable = _resolveComponent("ProductSlotsTable")
  const _component_ProductFAQs = _resolveComponent("ProductFAQs")
  const _component_NotificationsRestrictions = _resolveComponent("NotificationsRestrictions")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ProductSellingSettings = _resolveComponent("ProductSellingSettings")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.productItem.name), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("h5", _hoisted_8, [
                _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('product.productDetails')), 1),
                _hoisted_10
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('product.productName')) + ":", 1),
                    _createVNode("p", _hoisted_16, _toDisplayString(_ctx.productItem.name), 1)
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('product.shortDescription')) + ":", 1),
                    _createVNode("p", _hoisted_19, _toDisplayString(_ctx.productItem.shortDescription), 1)
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('product.longDescription')) + ":", 1),
                    _createVNode("p", {
                      class: ["product-text", _ctx.longDescriptionExpanded ? 'text-expanded' : 'text-not-expanded']
                    }, _toDisplayString(_ctx.productItem.fullDescription), 3)
                  ]),
                  (!_ctx.longDescriptionExpanded)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        class: "show-more-button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.longDescriptionExpanded = true))
                      }, _toDisplayString(_ctx.$t('button.showMore')), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('product.long-description-index')) + ":", 1),
                    _createVNode("p", {
                      class: ["product-text", _ctx.longDescriptionIndexExpanded ? 'text-expanded' : 'text-not-expanded']
                    }, _toDisplayString(_ctx.productItem.fullDescriptionIndex), 3)
                  ]),
                  (!_ctx.longDescriptionIndexExpanded)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        class: "show-more-button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.longDescriptionIndexExpanded = true))
                      }, _toDisplayString(_ctx.$t('button.showMore')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('product.region')) + ":", 1),
                    _createVNode("p", _hoisted_27, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productRegions, (region, index) => {
                        return (_openBlock(), _createBlock(_Fragment, {
                          key: region.id
                        }, [
                          _createVNode("span", null, _toDisplayString(region.regionName), 1),
                          (
                                                        _ctx.productItem.productRegions.length > 1 &&
                                                        index < _ctx.productItem.productRegions.length - 1
                                                    )
                            ? (_openBlock(), _createBlock("span", _hoisted_28, ", "))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('product.typeOfProduct')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_34, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productTypes, (tag) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: tag.id
                            }, [
                              (tag.id === _ctx.productItem.productTypeId)
                                ? (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(tag.name), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_36, [
                      _createVNode("div", _hoisted_37, [
                        _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('product.subTypes')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_39, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTypeTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (index < _ctx.subTypeTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_40, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _createVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('product.targetAudiences')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_44, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetAudiencesTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (index < _ctx.targetAudiencesTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_45, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_46, [
                      _createVNode("div", _hoisted_47, [
                        _createVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('product.entrance')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_49, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entranceTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (index < _ctx.entranceTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_50, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_51, [
                      _createVNode("div", _hoisted_52, [
                        _createVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('product.foodAndDrinks')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_54, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodDrinkTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (_ctx.foodDrinkTags().length > 1 && index < _ctx.foodDrinkTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_55, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_56, [
                      _createVNode("div", _hoisted_57, [
                        _createVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('product.religion')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_59, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.religionTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (index < _ctx.religionTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_60, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _createVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('product.difficultyLevel')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_64, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.difficultyLevelTags, (dif, i) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: i
                            }, [
                              _createVNode("span", null, _toDisplayString(dif.subTagName), 1),
                              (i < _ctx.difficultyLevelTags.length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_65, ","))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_66, [
                      _createVNode("div", _hoisted_67, [
                        _createVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('product.languages')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_69, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languagesTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (index < _ctx.languagesTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_70, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_71, [
                      _createVNode("div", _hoisted_72, [
                        _createVNode("span", _hoisted_73, _toDisplayString(_ctx.$t('product.transportAndParking')) + ":", 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_74, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transportAndParkingTags(), (subtag, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "product-text",
                              key: subtag.id
                            }, [
                              _createVNode("span", null, _toDisplayString(subtag.subTagName), 1),
                              (index < _ctx.transportAndParkingTags().length - 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_75, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_76, [
                  _createVNode("div", _hoisted_77, [
                    _createVNode("p", _hoisted_78, _toDisplayString(_ctx.$t('product.included')) + ":", 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productIncludedTags, (productIncludedTag, index) => {
                      return (_openBlock(), _createBlock("span", {
                        class: "product-text",
                        key: productIncludedTag.id
                      }, [
                        (index > 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_79, ", "))
                          : _createCommentVNode("", true),
                        _createVNode("span", null, _toDisplayString(productIncludedTag.subTagName), 1)
                      ]))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_80, [
                    _createVNode("p", _hoisted_81, _toDisplayString(_ctx.$t('product.excluded')) + ":", 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productExcludedTags, (productExcludedTag, index) => {
                      return (_openBlock(), _createBlock("span", {
                        class: "product-text",
                        key: productExcludedTag.id
                      }, [
                        (index > 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_82, ", "))
                          : _createCommentVNode("", true),
                        _createVNode("span", null, _toDisplayString(productExcludedTag.subTagName), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_83, [
                  _createVNode("div", _hoisted_84, [
                    _createVNode("p", _hoisted_85, _toDisplayString(_ctx.$t('product.averageActivityDuration')) + ":", 1),
                    _createVNode("span", _hoisted_86, _toDisplayString((_ctx.getAverageTime())), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_87, [
                  _createVNode("div", _hoisted_88, [
                    _createVNode("p", _hoisted_89, _toDisplayString(_ctx.$t('product.extraInfo')) + ":", 1),
                    (_ctx.productItem.extraInfo)
                      ? (_openBlock(), _createBlock("span", _hoisted_90, _toDisplayString(_ctx.productItem.extraInfo), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_91, [
                  _createVNode("div", _hoisted_92, [
                    _createVNode("p", _hoisted_93, _toDisplayString(_ctx.$t('product.receiveNotifications')) + ":", 1),
                    (_ctx.productItem.receiveNotifications)
                      ? (_openBlock(), _createBlock("p", _hoisted_94, _toDisplayString(_ctx.$t('product.active')), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_95, _toDisplayString(_ctx.$t('product.notActive')), 1))
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_96, [
            _createVNode("div", _hoisted_97, [
              _createVNode("h5", _hoisted_98, [
                _createVNode("button", _hoisted_99, _toDisplayString(_ctx.$t('product.productAddress')), 1),
                _hoisted_100
              ])
            ]),
            _createVNode("div", _hoisted_101, [
              _createVNode("div", _hoisted_102, [
                _createVNode("div", _hoisted_103, [
                  _createVNode("div", _hoisted_104, [
                    _createVNode("p", _hoisted_105, _toDisplayString(_ctx.$t('product.productAddress')) + ":", 1),
                    _createVNode("p", _hoisted_106, _toDisplayString(_ctx.productItem.address), 1)
                  ]),
                  (_ctx.productItem.longitude !== 0 && _ctx.productItem.latitude !== 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_107, [
                        _createVNode("p", _hoisted_108, _toDisplayString(_ctx.$t('address.map.location')) + ":", 1),
                        _createVNode("div", _hoisted_109, null, 512)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_110, [
                    _createVNode("p", _hoisted_111, _toDisplayString(_ctx.$t('product.city')) + ":", 1),
                    (_ctx.productItem && _ctx.productItem.city)
                      ? (_openBlock(), _createBlock("p", _hoisted_112, _toDisplayString(_ctx.productItem.city.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_113, [
                    _createVNode("p", _hoisted_114, _toDisplayString(_ctx.$t('product.region')) + ":", 1),
                    (_ctx.productItem && _ctx.productItem.region)
                      ? (_openBlock(), _createBlock("p", _hoisted_115, _toDisplayString(_ctx.productItem.region.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_116, [
                    _createVNode("p", _hoisted_117, _toDisplayString(_ctx.$t('address.arrival.instructions')) + ":", 1),
                    _createVNode("p", {
                      style: {"padding-inline-end":"30px"},
                      class: ["product-text mb-0", _ctx.arrivalInstructionsExpanded ? 'text-expanded' : 'text-not-expanded']
                    }, _toDisplayString(_ctx.productItem.arrivalInstructions), 3)
                  ]),
                  (!_ctx.arrivalInstructionsExpanded)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        class: "show-more-button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.arrivalInstructionsExpanded = true))
                      }, _toDisplayString(_ctx.$t('button.showMore')), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_118, [
                    _createVNode("p", _hoisted_119, _toDisplayString(_ctx.$t('address.parking.instructions')) + ":", 1),
                    _createVNode("p", {
                      style: {"padding-inline-end":"30px"},
                      class: ["product-text mb-0", _ctx.parkingInstructionsExpanded ? 'text-expanded' : 'text-not-expanded']
                    }, _toDisplayString(_ctx.productItem.parkingInstructions), 3)
                  ]),
                  (!_ctx.parkingInstructionsExpanded)
                    ? (_openBlock(), _createBlock("a", {
                        key: 2,
                        class: "show-more-button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.parkingInstructionsExpanded = true))
                      }, _toDisplayString(_ctx.$t('button.showMore')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_120, [
            _createVNode("div", _hoisted_121, [
              _createVNode("h5", _hoisted_122, [
                _createVNode("button", _hoisted_123, _toDisplayString(_ctx.$t('product.moreInfo')), 1),
                _hoisted_124
              ])
            ]),
            _createVNode("div", _hoisted_125, [
              _createVNode("div", _hoisted_126, [
                _createVNode("div", _hoisted_127, [
                  _createVNode(_component_ProductMoreInfo, {
                    editMode: false,
                    items: _ctx.productItem.productInfos
                  }, null, 8, ["items"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_128, [
            _createVNode("div", _hoisted_129, [
              _createVNode("h5", _hoisted_130, [
                _createVNode("button", _hoisted_131, _toDisplayString(_ctx.$t('product.productTime&Duration')), 1),
                _hoisted_132
              ])
            ]),
            _createVNode("div", _hoisted_133, [
              _createVNode("div", _hoisted_134, [
                _createVNode("div", _hoisted_135, [
                  _createVNode("a", {
                    href: _ctx.productItem.pmsLink,
                    class: "btn browse-photo browse-button green-button mr-3",
                    target: "_blank"
                  }, [
                    _hoisted_136,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('product.openCalendarInPms')), 1)
                  ], 8, ["href"]),
                  _createVNode("button", {
                    type: "button",
                    class: _ctx.showFilter ? 'filter-btn-pressed':'filter-btn',
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
                    _hoisted_137
                  ], 2)
                ]),
                _createVNode("div", _hoisted_138, [
                  _createVNode(_component_ProductSlotsTable, {
                    slots: _ctx.productItem.productSlots,
                    "edit-mode": false,
                    showFilter: _ctx.showFilter,
                    class: "mx-2"
                  }, null, 8, ["slots", "showFilter"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_139, [
            _createVNode("div", _hoisted_140, [
              _createVNode("h5", _hoisted_141, [
                _createVNode("button", _hoisted_142, _toDisplayString(_ctx.$t('product.photos&Video')), 1),
                _hoisted_143
              ])
            ]),
            _createVNode("div", _hoisted_144, [
              _createVNode("div", _hoisted_145, [
                _createVNode("div", _hoisted_146, [
                  (_ctx.productItem.productImages && _ctx.productItem.productImages.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_147, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productImages, (image, index) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "col-4 col-md-2 photo-container",
                            key: image.id
                          }, [
                            _createVNode("div", _hoisted_148, [
                              (image && !image.isConfirmed)
                                ? (_openBlock(), _createBlock("div", _hoisted_149, [
                                    _createVNode("div", {
                                      class: "mandatory-warning-info dp-none",
                                      id: 'product-image-' + index
                                    }, [
                                      _createVNode("div", _hoisted_150, _toDisplayString(_ctx.$t('product.image.notConfirmed')), 1)
                                    ], 8, ["id"]),
                                    _createVNode("div", _hoisted_151, [
                                      _createVNode("i", {
                                        class: "icon-f icon-not-confirmed fs-20",
                                        onMouseleave: ($event: any) => (_ctx.hideWarning(index)),
                                        onMouseenter: ($event: any) => (_ctx.showWarning(index))
                                      }, null, 40, ["onMouseleave", "onMouseenter"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (image.isMainImage)
                                ? (_openBlock(), _createBlock("span", _hoisted_152))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: image.pathSmall,
                                alt: image.name
                              }, null, 8, ["src", "alt"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_153, [
                        _createVNode("p", _hoisted_154, _toDisplayString(_ctx.$t('product.emptyPhotoLabel')), 1)
                      ]))
                ]),
                _createVNode("div", _hoisted_155, [
                  _createVNode("div", _hoisted_156, [
                    _createVNode("div", _hoisted_157, [
                      _createVNode("div", _hoisted_158, [
                        (!_ctx.productItem.ticketImagePath || !_ctx.productItem.ticketImagePathSmall)
                          ? (_openBlock(), _createBlock("p", _hoisted_159, _toDisplayString(_ctx.$t('ticket.productPage.title')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (_ctx.productItem.ticketImagePath && _ctx.productItem.ticketImagePathSmall)
                    ? (_openBlock(), _createBlock("div", _hoisted_160, [
                        _createVNode("div", _hoisted_161, [
                          _createVNode("div", _hoisted_162, [
                            _createVNode("img", {
                              src: _ctx.productItem.ticketImagePath
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_163, [
                          _createVNode("div", _hoisted_164, [
                            _createVNode("img", {
                              src: _ctx.productItem.ticketImagePathSmall
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_165, [
                  (_ctx.productItem.productVideos && _ctx.productItem.productVideos.length > 0)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("p", _hoisted_166, _toDisplayString(_ctx.$t('product.addVideo')) + ":", 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productVideos, (video, i) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "video-link row mx-auto col-12",
                            key: i
                          }, [
                            _createVNode("div", _hoisted_167, [
                              _createVNode("a", {
                                class: "product-text product-text-link",
                                href: video.path,
                                target: "_blank"
                              }, _toDisplayString(video.path), 9, ["href"])
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock("p", _hoisted_168, _toDisplayString(_ctx.$t('product.emptyVideoLabel')), 1))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_169, [
            _createVNode("div", _hoisted_170, [
              _createVNode("h5", _hoisted_171, [
                _createVNode("button", _hoisted_172, _toDisplayString(_ctx.$t('product.documents')), 1),
                _hoisted_173
              ])
            ]),
            _createVNode("div", _hoisted_174, [
              _createVNode("div", _hoisted_175, [
                _createVNode("div", _hoisted_176, [
                  (_ctx.productItem.productDocuments && _ctx.productItem.productDocuments.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_177, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productDocuments, (document) => {
                          return (_openBlock(), _createBlock("a", {
                            class: "col-4 col-md-2 document-container",
                            key: document.id,
                            target: "_blank",
                            href: document.path
                          }, [
                            _createVNode("div", _hoisted_178, [
                              _createVNode("p", _hoisted_179, _toDisplayString(document.name), 1),
                              _hoisted_180
                            ])
                          ], 8, ["href"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_181, [
                        _createVNode("p", _hoisted_182, _toDisplayString(_ctx.$t('product.emptyDocumentLabel')), 1)
                      ]))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_183, [
            _createVNode("div", _hoisted_184, [
              _createVNode("h5", _hoisted_185, [
                _createVNode("button", _hoisted_186, _toDisplayString(_ctx.$t('product.pricing')), 1),
                _hoisted_187
              ])
            ]),
            _createVNode("div", _hoisted_188, [
              _createVNode("div", _hoisted_189, [
                _createVNode("div", {
                  class: ["additional-section col-12",  _ctx.productItem.productPrices.length > 0 ? 'margin-bottom12' : '']
                }, [
                  _createVNode("div", _hoisted_190, [
                    _createVNode("div", _hoisted_191, [
                      _createVNode("button", {
                        class: "btn browse-photo browse-button green-button",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createNewPricing && _ctx.createNewPricing(...args))),
                        type: "button"
                      }, [
                        _hoisted_192,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('product.newPriceList')), 1)
                      ])
                    ])
                  ])
                ], 2),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productItem.productPrices, (pricing, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "several-section-wrapper",
                    key: pricing.id
                  }, [
                    (index < 3 || _ctx.showAllPrices)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "several-section pricing-section",
                          style: `opacity: ${pricing.deletedAt !== null ? '0.6' : ''}`
                        }, [
                          _createVNode("div", _hoisted_193, [
                            _createVNode("div", _hoisted_194, [
                              _createVNode("p", _hoisted_195, _toDisplayString(_ctx.$t('keyword.name')), 1),
                              _createVNode("p", _hoisted_196, _toDisplayString(pricing.title), 1)
                            ]),
                            _createVNode("div", _hoisted_197, [
                              _hoisted_198,
                              _createVNode("p", _hoisted_199, _toDisplayString(_ctx.momentFormat(pricing.fromDate, 'date')), 1),
                              _createVNode("p", _hoisted_200, _toDisplayString(_ctx.momentFormat(pricing.toDate, 'date')), 1)
                            ]),
                            _createVNode("div", _hoisted_201, [
                              _createVNode("p", _hoisted_202, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                              _createVNode("p", _hoisted_203, _toDisplayString(_ctx.findCurrencySymbol(pricing.id)), 1)
                            ]),
                            _createVNode("div", _hoisted_204, [
                              _createVNode("p", _hoisted_205, _toDisplayString(_ctx.$t('product.price-type')), 1),
                              _createVNode("p", _hoisted_206, _toDisplayString(_ctx.findPriceTypeName(pricing.id)), 1)
                            ])
                          ])
                        ], 4))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.productItem.productPrices.length > 3)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAllPrices = !_ctx.showAllPrices)),
                      class: "pointer text-center several-section m-0",
                      style: {"color":"#00bfdb","text-decoration":"underline"}
                    }, _toDisplayString(_ctx.showAllPrices ? _ctx.$t('btn.show-less') : _ctx.$t('btn.show-more')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_207, [
            _createVNode("div", _hoisted_208, [
              _createVNode("h5", _hoisted_209, [
                _createVNode("button", _hoisted_210, _toDisplayString(_ctx.$t('product.faq')), 1),
                _hoisted_211
              ])
            ]),
            _createVNode("div", _hoisted_212, [
              _createVNode("div", _hoisted_213, [
                _createVNode("div", _hoisted_214, [
                  _createVNode("p", _hoisted_215, _toDisplayString(_ctx.$t('product.faqInfo')), 1),
                  _createVNode(_component_ProductFAQs, {
                    editMode: false,
                    items: _ctx.productItem.productFaqs
                  }, null, 8, ["items"])
                ])
              ])
            ])
          ]),
          (_ctx.productItem.id)
            ? (_openBlock(), _createBlock("div", _hoisted_216, [
                _createVNode("div", _hoisted_217, [
                  _createVNode("h5", _hoisted_218, [
                    _createVNode("button", _hoisted_219, _toDisplayString(_ctx.$t('providers.notifications.title')), 1),
                    _hoisted_220
                  ])
                ]),
                _createVNode("div", _hoisted_221, [
                  _createVNode("div", _hoisted_222, [
                    _createVNode("div", _hoisted_223, [
                      _createVNode(_component_NotificationsRestrictions, {
                        productId: _ctx.productItem.id,
                        restrictions: _ctx.productItem.productsNotificationsRestrictions,
                        editMode: false
                      }, null, 8, ["productId", "restrictions"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_224, [
            _createVNode("div", _hoisted_225, [
              _createVNode("h5", _hoisted_226, [
                _createVNode("button", _hoisted_227, _toDisplayString(_ctx.$t('product.general')), 1),
                _hoisted_228
              ])
            ]),
            _createVNode("div", _hoisted_229, [
              _createVNode("div", _hoisted_230, [
                _createVNode("div", _hoisted_231, [
                  _createVNode("div", _hoisted_232, [
                    _createVNode("p", _hoisted_233, _toDisplayString(_ctx.$t('catalog.productId')) + ":", 1),
                    _createVNode("p", _hoisted_234, _toDisplayString(_ctx.productItem.id), 1)
                  ]),
                  _createVNode("div", _hoisted_235, [
                    _createVNode("p", _hoisted_236, _toDisplayString(_ctx.$t('product.createdDate')) + ":", 1),
                    _createVNode("p", _hoisted_237, _toDisplayString(_ctx.momentFormat(_ctx.productItem.createdAt, 'datetime')), 1)
                  ]),
                  _createVNode("div", _hoisted_238, [
                    _createVNode("p", _hoisted_239, _toDisplayString(_ctx.$t('catalog.calendarColor')) + ":", 1),
                    _createVNode("div", {
                      class: "small-circle-status",
                      style: `background:${_ctx.productItem.calendarColor};`
                    }, null, 4)
                  ]),
                  _createVNode("div", _hoisted_240, [
                    _createVNode("p", _hoisted_241, _toDisplayString(_ctx.$t('catalog.provider')) + ":", 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'provider-view', params: { id: _ctx.productItem.providerId } }
                    }, {
                      default: _withId(() => [
                        _createVNode("p", _hoisted_242, _toDisplayString(_ctx.productItem.providerName), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createVNode("div", _hoisted_243, [
                    _createVNode("p", _hoisted_244, _toDisplayString(_ctx.$t('product.status')) + ":", 1),
                    (_ctx.productItem.active)
                      ? (_openBlock(), _createBlock("p", _hoisted_245, _toDisplayString(_ctx.$t('product.active')), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_246, _toDisplayString(_ctx.$t('product.notActive')), 1))
                  ]),
                  _createVNode("div", _hoisted_247, [
                    _createVNode("p", _hoisted_248, _toDisplayString(_ctx.$t('product.isRegistrationRequired')) + ":", 1),
                    _createVNode("p", _hoisted_249, _toDisplayString(_ctx.getRegistrationTypeName(_ctx.productItem.registrationType)), 1)
                  ]),
                  _createVNode("div", _hoisted_250, [
                    _createVNode("p", _hoisted_251, _toDisplayString(_ctx.$t('product.operationStatus.title')) + ":", 1),
                    _createVNode("span", _hoisted_252, _toDisplayString((_ctx.getCurrentOperationStatus())), 1)
                  ]),
                  _createVNode("div", _hoisted_253, [
                    _createVNode("p", _hoisted_254, _toDisplayString(_ctx.$t('product.allowMultiplePriceLists')) + ":", 1),
                    (_ctx.productItem.allowMultiplePriceLists)
                      ? (_openBlock(), _createBlock("p", _hoisted_255, _toDisplayString(_ctx.$t('product.label.allowed')), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_256, _toDisplayString(_ctx.$t('product.label.notallowed')), 1))
                  ]),
                  _createVNode("div", _hoisted_257, [
                    _createVNode("p", _hoisted_258, _toDisplayString(_ctx.$t('product.canChangeOrderConfirmation')) + ":", 1),
                    (_ctx.productItem.canChangeOrderConfirmation)
                      ? (_openBlock(), _createBlock("p", _hoisted_259, _toDisplayString(_ctx.$t('product.label.allowed')), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_260, _toDisplayString(_ctx.$t('product.label.notallowed')), 1))
                  ]),
                  _createVNode("div", _hoisted_261, [
                    _createVNode("p", _hoisted_262, _toDisplayString(_ctx.$t('calendar.v3.modal.block-creating-new-orders')), 1),
                    (_ctx.productItem.orderBlockMinutes === null)
                      ? (_openBlock(), _createBlock("p", _hoisted_263, _toDisplayString(_ctx.$t('calendar.v3.modal.slot.allow')), 1))
                      : (_ctx.productItem.orderBlockMinutes === 0)
                        ? (_openBlock(), _createBlock("p", _hoisted_264, _toDisplayString(_ctx.$t('calendar.v3.modal.slot.after')), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_265, _toDisplayString(_ctx.productItem.orderBlockMinutes +
                                                    ' ' +
                                                    _ctx.$t('calendar.v3.modal.slot.' + _ctx.OrderBlockTypes[_ctx.productItem.selectedOrderBlockType])), 1))
                  ]),
                  _createVNode("div", _hoisted_266, [
                    _createVNode("p", _hoisted_267, _toDisplayString(_ctx.$t('product.specialId')) + ":", 1),
                    _createVNode("p", _hoisted_268, _toDisplayString(_ctx.productItem?.specialId), 1)
                  ]),
                  (_ctx.productItem?.orderLimitation != null)
                    ? (_openBlock(), _createBlock("div", _hoisted_269, [
                        _createVNode("p", _hoisted_270, _toDisplayString(_ctx.$t('catalog.order-limitation')), 1),
                        _createVNode("p", _hoisted_271, [
                          _createVNode("span", null, _toDisplayString(_ctx.formatAmountNoDecimal(_ctx.productItem.orderLimitation)) + " " + _toDisplayString(_ctx.$t('label.tickets')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_272, [
                    _createVNode("p", _hoisted_273, _toDisplayString(_ctx.$t('productPage.general.policyLabel')) + ":", 1)
                  ]),
                  _createVNode("div", _hoisted_274, [
                    _createVNode("p", _hoisted_275, _toDisplayString(_ctx.productItem.policy), 1)
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.priceTypes, (priceType) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-12 mt-12",
                      key: priceType.id
                    }, [
                      _createVNode("p", _hoisted_276, _toDisplayString(_ctx.$t(`product.canCreateSlotDuringCreatingOrder.${priceType.originName.replace(' ', '').toLocaleLowerCase()}`)) + ":", 1),
                      (_ctx.productItem.availableProductPriceTypes.includes(priceType.id))
                        ? (_openBlock(), _createBlock("p", _hoisted_277, _toDisplayString(_ctx.$t('product.active')), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_278, _toDisplayString(_ctx.$t('product.notActive')), 1))
                    ]))
                  }), 128)),
                  _createVNode("div", _hoisted_279, [
                    _createVNode("p", _hoisted_280, _toDisplayString(_ctx.$t('employee.allowed-assign-employees')) + ":", 1),
                    (_ctx.productItem.allowAssignEmployees)
                      ? (_openBlock(), _createBlock("p", _hoisted_281, _toDisplayString(_ctx.$t('product.active')), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_282, _toDisplayString(_ctx.$t('product.notActive')), 1))
                  ]),
                  _hoisted_283,
                  (_ctx.productItem.pricePerPerson)
                    ? (_openBlock(), _createBlock("div", _hoisted_284, [
                        _createVNode("span", _hoisted_285, _toDisplayString(_ctx.$t('product.pricePerPerson')), 1),
                        _createVNode("small", _hoisted_286, _toDisplayString(_ctx.$t('product.forExampleTicketForAFoodTour')), 1)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_287, [
                        _createVNode("span", _hoisted_288, _toDisplayString(_ctx.$t('product.pricePerUnit')), 1),
                        _createVNode("small", _hoisted_289, _toDisplayString(_ctx.$t('product.forExamplePriceForAJeep')), 1)
                      ]))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_290, [
            _createVNode("div", _hoisted_291, [
              _createVNode("h5", _hoisted_292, [
                _createVNode("button", _hoisted_293, _toDisplayString(_ctx.$t('product.about-responsible-person')), 1),
                _hoisted_294
              ])
            ]),
            _createVNode("div", _hoisted_295, [
              _createVNode("div", _hoisted_296, [
                _createVNode("div", _hoisted_297, [
                  (_ctx.productItem.responsiblePersonPhotoUrl)
                    ? (_openBlock(), _createBlock("div", _hoisted_298, [
                        _createVNode("img", {
                          src: _ctx.productItem.responsiblePersonPhotoUrl,
                          class: "about-me-round-image"
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    style: { 'grid-column': _ctx.productItem.responsiblePersonPhotoUrl ? 'span 1' : 'span 2' },
                    class: "respons-person-name-block"
                  }, [
                    _createVNode("p", _hoisted_299, _toDisplayString(_ctx.$t('about-responsible-person.full-name')) + ":", 1),
                    _createVNode("p", _hoisted_300, _toDisplayString(_ctx.productItem.responsiblePersonName), 1)
                  ], 4),
                  _createVNode("div", _hoisted_301, [
                    _createVNode("p", _hoisted_302, _toDisplayString(_ctx.$t('about-responsible-person.description')) + ":", 1),
                    _createVNode("p", _hoisted_303, _toDisplayString(_ctx.productItem.responsiblePersonDescription), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_304, [
            _createVNode("div", _hoisted_305, [
              _createVNode("h5", _hoisted_306, [
                _createVNode("button", _hoisted_307, _toDisplayString(_ctx.$t('product.selling-settings.name')), 1),
                _hoisted_308
              ])
            ]),
            _createVNode("div", _hoisted_309, [
              _createVNode("div", _hoisted_310, [
                _createVNode("div", _hoisted_311, [
                  _createVNode(_component_ProductSellingSettings, {
                    editMode: false,
                    useCashierProp: _ctx.productItem.useCashier,
                    useLocalsProp: _ctx.productItem.useLocals,
                    useGroupsProp: _ctx.productItem.useGroups,
                    useB2cChannelsProp: _ctx.productItem.useB2cChannels,
                    useIndexProp: _ctx.productItem.useIndex,
                    printingTypeProp: _ctx.productItem.printingType
                  }, null, 8, ["useCashierProp", "useLocalsProp", "useGroupsProp", "useB2cChannelsProp", "useIndexProp", "printingTypeProp"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_312, [
      _createVNode("button", {
        class: "arrow-button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
        type: "button"
      }, [
        _hoisted_313
      ]),
      _createVNode("div", _hoisted_314, [
        _createVNode("div", _hoisted_315, [
          _createVNode(_component_router_link, { to: { name: 'catalog' } }, {
            default: _withId(() => [
              _createVNode("button", _hoisted_316, _toDisplayString(_ctx.$t('button.catalog')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_317, [
          _createVNode(_component_router_link, {
            to: { name: 'edit-product', params: { id: _ctx.id } }
          }, {
            default: _withId(() => [
              _createVNode("button", _hoisted_318, [
                _hoisted_319,
                _createVNode("p", null, _toDisplayString(_ctx.$t('button.edit')), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
})